export enum ExternalAppsEnum {
  APP_GESTAO = 'app-gestao',
  SERU_DELIVERY = 'seru-delivery',
}

export const ExternalAppsLabelsEnum: Record<ExternalAppsEnum, string> = {
  [ExternalAppsEnum.APP_GESTAO]: 'App Gestão',
  [ExternalAppsEnum.SERU_DELIVERY]: 'Colibri Delivery',
};
